import { useEffect, useState } from "react";
import axios from "axios";
import { routes } from "../gen/General";
import { Carousel, CarouselIndicators, CarouselItem } from "reactstrap";

export const CarouselPrestadores = () => {
    const [items, setItems] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const [autoPlay, setAutoPlay] = useState(true);

    useEffect(() => {
        axios.get(routes.apiVam + "/banner/obtener/banner").then(resp => setItems(resp.data?.itemsBeneficios || []));
    }, []);

    useEffect(() => {
        console.log(activeIndex);
        console.log(items[activeIndex]?.btnType);
        if (items.length > 0 && items[activeIndex]?.btnType === "1") {
            setAutoPlay(false);
        } else {
            setAutoPlay(true);
        }
    }, [activeIndex]);

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const goToIndex = newIndex => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    const slides = (items || []).map((item, index) => {
        return (
            <CarouselItem onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)} key={index}>
                <div className={"carousel-caption"}>
                    <div className={"container text-primary d-flex align-items-end"}>
                        <div className={"row w-100 justify-content-between"}>
                            {item.btnType !== "1" && (
                                <div className={"col-xl-8 text-left d-flex flex-column justify-content-around"}>
                                    <h1>{item.title}</h1>
                                    <h5>{item.subtitle}</h5>
                                    <span>{item.content}</span>
                                </div>
                            )}
                            {item.btnType === "2" ? (
                                <div className="col imagen-fondo" style={{ backgroundImage: `url(${item.src})` }} />
                            ) : (
                                <div className={"video-frame"}>
                                    <div className="popup-video">
                                        <div className="embed-responsive embed-responsive-16by9">
                                            <iframe src={item.btnLink} allowFullScreen />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </CarouselItem>
        );
    });

    return (
        <Carousel interval={false} activeIndex={activeIndex} next={next} previous={previous}>
            <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
            {slides}
            {/* <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous}/>
            <CarouselControl direction="next" directionText="Next" onClickHandler={next}/>*/}
        </Carousel>
    );
};
